module.exports = __webpack_public_path__ + "media/images/design/common/images/li_icon-2700de2114dd8cfbcdc1005fbb9ebb0b.png";